import { CommunityRecovery } from './communityRecovery.js';
import { Ramp } from './ramp.js';
import { Assets } from './assets.js';
import { Token } from './token.js';
import { Transaction } from './transaction.js';
import { Activity } from './activity.js';
import { Security } from './security.js';
import { Allowance } from './allowance.js';
import { Common } from './common.js';
import { Receive } from './receive.js';
import { Send } from './send.js';
export class Services extends CommunityRecovery {
    constructor(request, didGraphQL, referralConfig, extraInfoConfig) {
        super(request, didGraphQL, referralConfig, extraInfoConfig);
        this.communityRecovery = new CommunityRecovery(request, didGraphQL, referralConfig, extraInfoConfig);
        this.ramp = new Ramp(request);
        this.assets = new Assets(request);
        this.token = new Token(request);
        this.transaction = new Transaction(request);
        this.activity = new Activity(request);
        this.security = new Security(request);
        this.allowance = new Allowance(request);
        this.common = new Common(request);
        this.receive = new Receive(request);
        this.send = new Send(request);
    }
}
